module.exports = __webpack_public_path__ + "static/media/lightbox_down.8b9e3ad8.svg";